/**
 * Account-type lookup table by country code. Promoted from
 * `@/modules/contacts/utils/destinataryTypes.util` so that shared/common
 * utilities (`transactionModalData.util`) stop importing from
 * `@/modules/*`. The contacts module re-exports `accountTypesData` and
 * `AccountType` / `AccountTypesData` from here to preserve existing
 * call sites.
 */
export type AccountType = {
  text: string;
  value: string;
  valueMultiRemittance: string;
};

export type AccountTypesData = {
  [key: string]: AccountType[];
};

export const accountTypesData: AccountTypesData = {
  BR: [
    { text: 'Ahorro (Poupança)', value: 'Saving', valueMultiRemittance: 'CA' },
    { text: 'Corriente', value: 'Checking', valueMultiRemittance: 'CC' },
  ],
  CL: [
    { text: 'Cuenta Ahorro', value: 'Saving', valueMultiRemittance: 'CA' },
    { text: 'Cuenta Corriente', value: 'Checking', valueMultiRemittance: 'CC' },
    { text: 'Cuenta Vista', value: 'Vista', valueMultiRemittance: 'CV' },
    { text: 'Cuenta RUT', value: 'RUT', valueMultiRemittance: 'CR' },
  ],
  default: [
    { text: 'Ahorro', value: 'Saving', valueMultiRemittance: 'CA' },
    { text: 'Corriente', value: 'Checking', valueMultiRemittance: 'CC' },
  ],
};
